var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepasse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.95V13.825H4V12.325H9.5V9.70001H4.775C4.575 9.70001 4.39583 9.62501 4.2375 9.47501C4.07917 9.32501 4 9.14168 4 8.92501V4.82501C4 4.60835 4.075 4.42918 4.225 4.28751C4.375 4.14585 4.55 4.07501 4.75 4.07501H6.75V2.95001H8.25V4.07501H11V5.57501H5.5V8.20001H10.225C10.4417 8.20001 10.625 8.27085 10.775 8.41251C10.925 8.55418 11 8.74168 11 8.97501V13.075C11 13.275 10.9292 13.45 10.7875 13.6C10.6458 13.75 10.4667 13.825 10.25 13.825H8.25V14.95H6.75ZM13.95 20.95L9.7 16.7L10.75 15.65L13.95 18.85L19.95 12.85L21 13.9L13.95 20.95Z",
    fill: "url(#paint0_linear_334_336)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_336",
    x1: 12.5,
    y1: 2.95002,
    x2: 12.5,
    y2: 20.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepasse);
export default __webpack_public_path__ + "static/media/repasse.d5fcf31765fdc83be76cc9ab284e02c3.svg";
export { ForwardRef as ReactComponent };